export default __webpack_public_path__ + "static/data-free-for-beta-15cc234778ed4eacc0dd5ed11ed303aa.webp";